import React, { useContext, useEffect, useState } from "react";
// React Bootstrap
import { Accordion, Card, Button } from "react-bootstrap";
// Componentes
import Vinculacion from "./Vinculacion";
import FormVinculacion from "../formularios/FormVinculacion";
// Contexto
import { ModalContext } from "../../../context/modalContext";
import { AlertBoxContext } from "../../../context/alertBoxContext";
// jquery
import $ from "jquery";
// Custom spinner
import CustomSpinner from "../../generic/CustomSpinner";

const Vinculaciones = ({ idProvincia, idComunidad, ...props }) => {
  // Contexto
  const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);
  // Datos de las vinculaciones de la comunidad
  const [datosVinculaciones, setDatosVinculaciones] = useState([]);
  // Custom spinner
  const [loading, setLoading] = useState(false);
  // Alertas
  const { addAlert } = useContext(AlertBoxContext);

  useEffect(() => {
    handleGetDatosVinculaciones();
  }, []);

  // Obtiene los datos de las Vinculaciones de una comunidad
  const getDatosVinculaciones = () => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/provincias/${idProvincia}/comunidades/${idComunidad}/eclesiasticos?count=9999`,
      method: "GET",
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  };

  // Añade una vinculacion de una comunidad
  const postDatosVinculacion = (data) => {
    let settings = {
      url: process.env.REACT_APP_API_URL + `/provincias/${idProvincia}/comunidades/${idComunidad}/eclesiasticos`,
      method: "POST",
      xhrFields: {
        withCredentials: true,
      },
      data: data,
    };
    return $.ajax(settings);
  };

  // Manejador para obtener los datos de las Vinculaciones de la comunidad
  const handleGetDatosVinculaciones = () => {
    setLoading(true);
    getDatosVinculaciones()
      .then((response) => {
        setLoading(false);
        setDatosVinculaciones(response.items);
      })
      .catch(() => {
        setLoading(false);
        props?.ErrorHandling();
      });
  };

  // Manejador para el put de los datos de las vinculaciones de la comunidad
  const handlePostDatosVinculacion = (data) => {
    setLoading(true);
    modalSetShow(false);
    // Hacemos el put para los datos de las vinculaciones
    postDatosVinculacion(data)
      .then((response) => {
        setDatosVinculaciones([...datosVinculaciones, response]);
        addAlert("Exito", "Se ha añadido correctamente la vinculación eclesiástica de la comunidad", "success");
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        props?.ErrorHandling();
      });
  };

  // Elimina una vinculacion del estado con el id de la vinculacion
  const deleteVinculacionState = (idVinculacion) => {
    let vinculacion = datosVinculaciones.find((vinculacion) => vinculacion.id === idVinculacion);
    let misVinculaciones = [...datosVinculaciones];
    misVinculaciones.splice(misVinculaciones.indexOf(vinculacion), 1);
    setDatosVinculaciones(misVinculaciones);
  };

  return (
    <div className="position-relative">
      <CustomSpinner animation={"border"} loading={loading} />
      <Accordion defaultActiveKey="1">
        <Card>
          <Card.Header>
            <Accordion.Toggle eventKey="0" as={Button} variant="link">
              Vinculación con otros organismos
              {/* Antiguamente vinculacion eclesial */}
            </Accordion.Toggle>
            <Button
              variant="outline-primary"
              size="sm"
              className="float-right mr-4"
              onClick={() => {
                modalSetShow(true, "80%");
                modalSetTitle("Añadir vinculación");
                modalSetContent(<FormVinculacion submissionHandler={handlePostDatosVinculacion} />);
              }}
            >
              Añadir
            </Button>
          </Card.Header>
          <Accordion.Collapse eventKey="0" className="p-3">
            <>
              {datosVinculaciones.length ? (
                datosVinculaciones.map((vinculacion) => {
                  return <Vinculacion key={vinculacion.id} idProvincia={idProvincia} idComunidad={idComunidad} vinculacion={vinculacion} deleteVinculacionState={deleteVinculacionState} />;
                })
              ) : (
                <p>No hay vinculaciones eclesiásticas actualmente </p>
              )}
            </>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

export default Vinculaciones;
